module.exports = __webpack_public_path__ + "img/1.813c3149.jpg";